<template lang="pug">
.time-machine-wrapper
  .main-display
    .meter-container
      svg.meter-svg(viewBox="0 0 260 130")
        defs
          linearGradient#ringGradient
            stop(offset="0%" stop-color="#00ee6e")
            stop(offset="100%" stop-color="#722df2")
          radialGradient#sweepGradient
            stop(offset="0%" stop-color="#ffb300" stop-opacity="0.9")
            stop(offset="100%" stop-color="#ffe082" stop-opacity="0.5")
        circle(
          ref="sweepPath"
          cx="130" cy="130" r="47.5"
          fill="none"
          stroke="url(#sweepGradient)"
          stroke-width="95"
          stroke-dasharray="298.45"
          stroke-dashoffset="298.45"
          transform="rotate(180 130 130)"
          style="transition: stroke-dashoffset 0.2s ease-out;"
        )
        g.icon-stroke(stroke-width="2" stroke-linecap="round")
          line(x1="35" y1="130" x2="42" y2="130" transform="rotate(0 130 130)")
          line(x1="35" y1="130" x2="42" y2="130" transform="rotate(20 130 130)")
          line(x1="35" y1="130" x2="42" y2="130" transform="rotate(40 130 130)")
          line(x1="35" y1="130" x2="42" y2="130" transform="rotate(60 130 130)")
          line(x1="35" y1="130" x2="42" y2="130" transform="rotate(80 130 130)")
          line(x1="35" y1="130" x2="42" y2="130" transform="rotate(100 130 130)")
          line(x1="35" y1="130" x2="42" y2="130" transform="rotate(120 130 130)")
          line(x1="35" y1="130" x2="42" y2="130" transform="rotate(140 130 130)")
          line(x1="35" y1="130" x2="42" y2="130" transform="rotate(160 130 130)")
          line(x1="35" y1="130" x2="42" y2="130" transform="rotate(180 130 130)")
        path(d="M 15 130 A 115 115 0 0 1 245 130"
          fill="none"
          stroke="url(#ringGradient)"
          stroke-width="12"
          stroke-linecap="round")
      .meter-marks
        .meter-mark.mark-0 0'
        .meter-mark.mark-45 45'
        .meter-mark.mark-90 90'
      .needle-wrapper(ref="meterPointer")
        .needle
      .pivot
      .bubble-pivot(ref="bubblePivot")
        #timeBubble.time-bubble(ref="timeBubble") {{rValueInt}}'
  .slider-section
    button.control-btn(ref="btnMinus" :disabled="minusBtnClicked" @click="updateTime(rValueInt - 1)") -
    .slider-wrapper
      input#timeSlider(type="range" :min="0" max="90" v-model.number="rValueInt"
        @input="onInput" :style="{ '--min-progress': minProgress }" )
      .marker-min-time(:style="{left: (this.$store.getters.timeMachine.min + (this.$store.getters.timeMachine.min/10))+'%'}") {{minTime}}'
    button.control-btn(ref="btnPlus" :disabled="plusBtnClicked" @click="updateTime(rValueInt + 1)") +
  .quick-buttons
    button.quick-btn(v-for="i in 9" :data-time="i*10" @click="updateTime(i*10)" :class="{active: rValueInt===i*10}" ) {{i*10}}'
</template>

<script>
export default {
  props: {
    rangeValue: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      rValueInt: this.rangeValue,
      minusBtnClicked: true,
      plusBtnClicked: false
    };
  },
  computed: {
    time_machine() {
      return this.$store.getters.timeMachine || {};
    },
    minTime() {
      return this.time_machine.min;
    },
    maxTime() {
      return this.time_machine.max;
    },
    minProgress() {
      return `${(this.minTime / this.maxTime) * 100}%`;
    }
  },
  watch: {
    rangeValue(newVal) {
      this.rValueInt = newVal;
      this.syncButtonStates(newVal);
      this.$nextTick(() => this.setRefTransform(this.rValueInt));
    },
    minTime(newVal) {
      this.syncButtonStates(this.rValueInt);
    }
  },
  mounted() {
    this.syncButtonStates(this.rValueInt);
    this.$nextTick(() => this.setRefTransform(this.rValueInt));
  },
  methods: {
    syncButtonStates(val) {
      const atLimit = this.minTime === this.maxTime;
      this.minusBtnClicked = val <= this.minTime || atLimit;
      this.plusBtnClicked = val >= this.maxTime || atLimit;
    },

    setRefTransform(val) {
      const currentDegree = -90 + val * 2;
      const negDegree = -currentDegree;
      const { meterPointer, bubblePivot, timeBubble, sweepPath } = this.$refs;

      if (meterPointer) meterPointer.style.transform = `rotate(${currentDegree}deg)`;
      if (bubblePivot) bubblePivot.style.transform = `rotate(${currentDegree}deg)`;
      if (timeBubble) timeBubble.style.transform = `translate(-50%, -50%) rotate(${negDegree}deg)`;

      if (sweepPath) {
        const SWEEP_TOTAL_DASH = 298.45;
        sweepPath.style.strokeDashoffset = SWEEP_TOTAL_DASH * (1 - val / 180);
      }
    },
    updateTime(newValue) {
      const confirmValue = Math.max(this.minTime, Math.min(this.maxTime, newValue));
      if (newValue >= this.minTime) {
        this.$emit("update-range", confirmValue);
      } else {
        this.rValueInt = this.rangeValue;
      }
    },
    onInput(event) {
      const newValue = Number(event.target.value) || 0;
      if (newValue <= this.minTime) {
        this.rValueInt = this.rangeValue;
        return;
      }
      this.updateTime(newValue);
    }
  }
};
</script>
